export enum TipoAcaoOperacao {
  _00_LOGIN = 'Login',
  _01_INSERT = 'Inserção',
  _02_UPDATE = 'Atualização',
  _03_UNDO = 'Desfazer',
  _04_DELETE = 'Remoção',
  _05_GET = 'Consulta',
  _06_NOTIFY = 'Notificação',
}

export enum TipoAcaoRefTo {
  _00_DISCIPLINA = 'Disciplina',
  _01_INSCRICAO = 'Inscrição',
  _02_CARGA_HORARIA = 'Carga horária',
  _03_PLANO_ATIVIDADES = 'Plano de atividades',
  _04_RELATORIO_ATIVIDADES = 'Relatório de atividades',
  _05_CERTIFICADO = 'Certificado',
}

export const TipoAcaoOpDescricaoTxt = new Map<string, string>([
  ['LOGIN', 'Login'],
  ['INSERT', 'Inserir'],
  ['UPDATE', 'Atualizar'],
  ['DELETE', 'Excluír'],
  ['GET', 'Consultar'],
  ['EXCEPTION', 'Exceção'],
  ['NOTIFY', 'Notificação'],
  ['UNDO', 'Desfazer em'],
])

export const TipoAcaoRefToDescricaoTxt = new Map<string, string[]>([
  ['DISCIPLINA', ['Disciplina', '', '_00_DISCIPLINA', '']],
  ['INSCRICAO', ['Inscrição', '', '_01_INSCRICAO', '']],
  ['CARGA_HORARIA', ['Carga horária', '', '_02_CARGA_HORARIA', '']],
  ['PLANO_ATIVIDADES', ['Plano de atividades', '', ' _03_PLANO_ATIVIDADES', '']],
  ['RELATORIO_ATIVIDADES', ['Relatório de atividades', '', '_04_RELATORIO_ATIVIDADES', '']],
  ['CERTIFICADO', ['Certificado', '', '_05_CERTIFICADO', '']],
  ['EXCEPTION', ['Exceção', '', '_05_EXCEPTION', '']],
])

export function getAcaoDescricaoTxt(acao: string): string {
  const [operacao] = acao.split('_', 2)
  const refTo = acao.slice(acao.indexOf('_') + 1) || ''
  let op = TipoAcaoOpDescricaoTxt.get(operacao) || ''
  const refArr = TipoAcaoRefToDescricaoTxt.get(refTo)
  return `${op} ${refArr && refArr[0] ? refArr[0] : ''}`
}
